import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { useFieldControlProps } from './field';
import './styles/textarea.css';

function cx(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(' ');
}

export type TextareaProps = {
  invalid?: boolean;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  {
    invalid,
    className,
    disabled,
    readOnly,
    id,
    required,
    'aria-describedby': ariaDescribedBy,
    'aria-invalid': ariaInvalid,
    'aria-required': ariaRequired,
    ...rest
  },
  ref,
) {
  const fieldProps = useFieldControlProps({
    id,
    invalid,
    disabled,
    readOnly,
    required,
    'aria-describedby': ariaDescribedBy,
    'aria-invalid': ariaInvalid,
    'aria-required': ariaRequired,
  });
  const isInvalid = fieldProps.invalid ?? invalid;
  const isDisabled = fieldProps.disabled ?? disabled;
  const isReadOnly = fieldProps.readOnly ?? readOnly;

  return (
    <textarea
      {...rest}
      ref={ref}
      id={fieldProps.id}
      required={fieldProps.required}
      disabled={isDisabled}
      readOnly={isReadOnly}
      aria-describedby={fieldProps['aria-describedby']}
      aria-invalid={fieldProps['aria-invalid']}
      aria-required={fieldProps['aria-required']}
      className={cx('cev-textarea', isInvalid && 'cev-textarea--invalid', className)}
    />
  );
});
Textarea.displayName = 'cevopTextarea';
